import { create } from 'zustand';
import { WorkOrderStatus, WorkOrderPriority, WorkOrderEquipmentType } from '../../types/work-order';

interface WorkOrdersState {
  // Search and filters
  search: string;
  statusFilter: WorkOrderStatus[];
  priorityFilter: WorkOrderPriority[];
  equipmentTypeFilter: WorkOrderEquipmentType | null;
  technicianFilter: string | null;
  // Pagination
  page: number;
  limit: number;
}

interface WorkOrdersActions {
  setSearch: (search: string) => void;
  setStatusFilter: (filter: WorkOrderStatus[]) => void;
  setPriorityFilter: (filter: WorkOrderPriority[]) => void;
  setEquipmentTypeFilter: (filter: WorkOrderEquipmentType | null) => void;
  setTechnicianFilter: (filter: string | null) => void;
  setPage: (page: number) => void;
  setLimit: (limit: number) => void;
  resetAll: () => void;
}

type WorkOrdersStore = WorkOrdersState & WorkOrdersActions;

const initialState: WorkOrdersState = {
  search: '',
  statusFilter: [],
  priorityFilter: [],
  equipmentTypeFilter: null,
  technicianFilter: null,
  page: 1,
  limit: 25,
};

export const useWorkOrdersStore = create<WorkOrdersStore>()((set) => ({
  ...initialState,

  setSearch: (search) => set({ search, page: 1 }),
  setStatusFilter: (statusFilter) => set({ statusFilter, page: 1 }),
  setPriorityFilter: (priorityFilter) => set({ priorityFilter, page: 1 }),
  setEquipmentTypeFilter: (equipmentTypeFilter) => set({ equipmentTypeFilter, page: 1 }),
  setTechnicianFilter: (technicianFilter) => set({ technicianFilter, page: 1 }),
  setPage: (page) => set({ page }),
  setLimit: (limit) => set({ limit, page: 1 }),
  resetAll: () => set(initialState),
}));
